import React from 'react';
import ReactDOMServer from 'react-dom/server';
import Rating from 'react-rating';

import canvg from 'canvg';

import starEmpty from 'assets/img/star-grey.png';
import starFull from 'assets/img/star.png';

import starEmpty2 from 'assets/img/starEmpty.png'
import starFull2 from 'assets/img/starFull.png'

import { Container } from './styles';

export default function RatingComponent({
  ratingTask = false,
  fractions = 1,
  initialRating = 0,
  start = 0,
  stop = 5,
  onChange,
  readonly,
  starSize,
}) {
  return (
    <Container starSize={starSize}>
      <Rating
        ratingTask={ratingTask}
        start={start}
        stop={stop}
        emptySymbol={<img src={ ratingTask ? starEmpty2 : starEmpty} alt="star" />}
        fullSymbol={<img src={ratingTask ? starFull2 : starFull} alt="star" />}
        fractions={fractions}
        initialRating={initialRating}
        onChange={onChange}
        readonly={readonly}
      />
    </Container>
  );
}

class RatingSVG extends React.Component {
  constructor(props) {
    super(props);
    this.id = RatingSVG.id;
    RatingSVG.id += 1;
  }

  render() {
    const {
      size, strokeWidth, stroke, rate, frontColor, backgroundColor, ...rest
    } = this.props;
    const id = `star_filter${this.id}`;

    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width={size}
        height={size}
      >
        <defs>
          <linearGradient id={id}>
            <stop offset={`${rate * 100}%`} stopColor={frontColor} />
            <stop offset="0%" stopColor={backgroundColor} stopOpacity="1" />
          </linearGradient>
        </defs>
        <path
          d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,
                 31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,
                 12.118l11.547-1.2L16.026,0.6L20.388,10.918z"
          fill={`url(#${id})`}
        />
      </svg>
    );
  }
}

RatingSVG.id = 0;

RatingSVG.defaultProps = {
  strokeWidth: 0,
  stroke: '#F8CC46',
  rate: 0,
  backgroundColor: '#FFF',
  frontColor: '#F8CC46',
};

const getRatingStar = (r, i) => {
  const diff = r - i;
  if (r >= i || diff > 0) return 1;
  const mod = diff * -1;
  if (mod > 1) return 0;
  return 1 - mod;
};

const PIXEL_RATIO = (function () {
  const ctx = document.createElement('canvas').getContext('2d');
  const dpr = window.devicePixelRatio || 1;
  const bsr = ctx.webkitBackingStorePixelRatio
    || ctx.mozBackingStorePixelRatio
    || ctx.msBackingStorePixelRatio
    || ctx.oBackingStorePixelRatio
    || ctx.backingStorePixelRatio
    || 1;

  return dpr / bsr;
}());

export const getStarsPNG = (rating) => {
  const stars = [];
  for (let i = 1; i <= 5; i += 1) {
    const rate = getRatingStar(parseFloat(rating), i);

    const size = 100;

    const htmlString = ReactDOMServer.renderToStaticMarkup(<RatingSVG rate={rate} size={size} />);

    const ratio = PIXEL_RATIO;

    const canvas = document.createElement('canvas');

    canvas.width = size * ratio;
    canvas.height = size * ratio;
    canvas.style.width = `${size}px`;
    canvas.style.height = `${size}px`;
    canvas.getContext('2d');
    canvg(canvas, htmlString, {
      ignoreDimensions: true,
      scaleWidth: canvas.width,
      scaleHeight: canvas.height,
    });
    const png = canvas.toDataURL('image/png', 1.0);
    stars.push(png);
  }

  return stars;
};
